/// <amd-module name="Search/Code/Components/BranchFilterItem" />

import * as React from "react";
import * as SearchShared from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";
import { Icon } from "VSSUI/Icon";
import { HighlightComponent } from "Search/Shared/Components/HighlightComponent";

export interface IBranchFilterItemProps {
    item: SearchShared.Filter;

    hitText: string;
}

export const BranchFilterItem = (props: IBranchFilterItemProps) => {
    return (
        <div className="search-branch-filter-item flex-row">
            <Icon className="source-icon" iconName="BranchFork2" />
            <HighlightComponent text={props.item.id} pattern={props.hitText} />
        </div>
    );
}